import React, { useState, useEffect } from 'react';
import { Progress } from 'cccisd-laravel-assignment';
import Loader from 'cccisd-loader';
import query from './providerNames.graphql';
import { client } from 'cccisd-apollo';
import usePdProjectId from '../usePdProjectId.js';

const ProviderProgress = props => {
    const [providers, setProviders] = useState();
    const [projectId, loadingProjectId] = usePdProjectId();

    useEffect(() => {
        (async () => {
            const response = await client.query({
                query,
                fetchPolicy: 'network-only',
            });

            setProviders(
                response.data.roles.instructorList.reduce((obj, item) => {
                    obj[item.pawn.pawnId] = item.user.fullNameWithUsername;
                    return obj;
                }, {})
            );
        })();
    }, []);

    if (!providers || loadingProjectId) {
        return <Loader loading />;
    }

    const adjustColumns = ({ columns }) => {
        return [
            {
                name: 'name',
                label: 'Provider',
                render: ({ row }) => {
                    return providers[row['pawn.pawnId']];
                },
            },
            ...columns.filter(column => column.name !== 'pawn.pawnId'),
        ];
    };

    return (
        <Progress
            projectId={projectId}
            hideProjectDropdown
            hideDeploymentDropdown
            labelForQuest="Course"
            showByWhitelist={['assignment']}
            adjustColumns={adjustColumns}
        />
    );
};

export default ProviderProgress;
